export interface Stance {
  id: string;
  name: string;
  description: string;
}

export interface StancesByTier {
  1: Stance[];
  2: Stance[];
  3: Stance[];
  4: Stance[];
}

export const BRAWLER_STANCES: StancesByTier = {
  1: [
    {
      id: 'brutal',
      name: 'Brutal',
      description: 'When you roll the maximum value on a damage die, roll an additional damage die.',
    },
    {
      id: 'defensive',
      name: 'Defensive',
      description: 'Attack rolls against you have disadvantage unless the adversary marks a Stress.',
    },
    {
      id: 'grappling',
      name: 'Grappling',
      description: 'On a successful attack, you can spend a Focus to make the target temporarily Restrained.',
    },
    {
      id: 'steady',
      name: 'Steady',
      description: 'Gain a -1 penalty to your Evasion. When you deal damage on a successful attack, roll an additional damage die and drop the lowest.',
    },
    {
      id: 'precise',
      name: 'Precise',
      description: 'Gain a +1 bonus to your attack rolls.',
    },
    {
      id: 'quick',
      name: 'Quick',
      description: 'When making an attack roll, spend a Focus to include an additional target within range.',
    },
  ],
  2: [
    {
      id: 'deadly',
      name: 'Deadly',
      description: 'When you deal Severe damage, the target marks an additional HP.',
    },
    {
      id: 'hindering',
      name: 'Hindering',
      description: 'On a successful attack, you can spend a Focus to make the target temporarily Hindered. While Hindered, their attack rolls have a -2 penalty.',
    },
    {
      id: 'invigorating',
      name: 'Invigorating',
      description: 'When you make a successful attack, roll a d4. On a 4, gain a Focus.',
    },
    {
      id: 'immovable',
      name: 'Immovable',
      description: 'Gain a +2 bonus to your damage thresholds and you cannot be moved unwillingly.',
    },
    {
      id: 'nimble',
      name: 'Nimble',
      description: 'When an adversary makes a successful attack roll against you, you can spend a number of Focus up to your Tier. Roll a number of d6s equal to 1 + the Focus spent. If any of the dice values match, you take no damage from the attack.',
    },
    {
      id: 'otherworldly',
      name: 'Otherworldly',
      description: 'You can choose whether to do Physical or Magic damage.',
    },
    {
      id: 'scary',
      name: 'Scary',
      description: 'Successful attacks also force the target to mark a Stress.',
    },
  ],
  3: [
    {
      id: 'deflecting',
      name: 'Deflecting',
      description: 'When you are targeted by an attack, you can spend 2 Focus to gain a bonus to your Evasion equal to your Armor Score against the attack.',
    },
    {
      id: 'devastating',
      name: 'Devastating',
      description: 'Spend a Focus before your attack roll to use d20s as your damage dice instead.',
    },
    {
      id: 'dueling',
      name: 'Dueling',
      description: 'Gain advantage on attack rolls when there are no other adversaries or allies in Very Close range of you or your target.',
    },
    {
      id: 'compounding',
      name: 'Compounding',
      description: 'When you roll the maximum value on a Combo Die, increase the size of the subsequent Combo Dice you roll for the attack (at a maximum of d12s).',
    },
    {
      id: 'inexorable',
      name: 'Inexorable',
      description: 'Attacks against you have disadvantage if you have more than two adversaries within Melee of you.',
    },
    {
      id: 'favored',
      name: 'Favored',
      description: 'Add the trait of your choice to your damage roll.',
    },
    {
      id: 'sheltering',
      name: 'Sheltering',
      description: 'When you mark an Armor Slot, it reduces damage for you and all allies within Melee range of you who took the same damage.',
    },
  ],
  4: [
    {
      id: 'crushing',
      name: 'Crushing',
      description: 'When you roll a 1 on a damage die, it can be treated as the highest value on the die instead.',
    },
    {
      id: 'infuriating',
      name: 'Infuriating',
      description: 'On a successful attack, the target becomes Furious. While Furious, they are Vulnerable and have a -2 penalty to their attack rolls. They can only clear Furious by succeeding on an attack against you.',
    },
    {
      id: 'sweeping',
      name: 'Sweeping',
      description: 'Your attack targets all adversaries within Very Close range. Deal half damage to all targets you succeed against.',
    },
    {
      id: 'discerning',
      name: 'Discerning',
      description: 'You may choose the target of your attack after making your attack roll. The GM will tell you who the attack would succeed against.',
    },
  ],
};